import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Criticals } from '../../models/itens.model';

@Component({
  selector: 'app-itens-check-critical',
  templateUrl: './itens-check-critical.component.html',
  styleUrls: ['./itens-check-critical.component.scss','../itens-edit/itens-edit.component.scss']
})
export class ItensCheckCriticalComponent extends BaseFormComponent<Criticals> implements OnInit {
    @Input() parentFormGroup: FormGroup = null;
    @Input() currentItem: object[] = [];
    @Output() checkStatus = new EventEmitter<void>();
    status = {'1':'Baixo', '2':'Medio', '3':'Alto', '4':'Ponto crítico ativo'};
    constructor(
      public activatedRoute: ActivatedRoute,
    ) { 
      super(activatedRoute);
  
    }
    
    get criticals(): FormArray {
      return this.parentFormGroup.get('criticals') as FormArray;
    }
    
    getFormArray(){
      return this.criticals.get('criticals') as FormArray;
    }

    ngOnInit() {
    }

    getStatus(line:Criticals){
      var probability_id = line.critical_probability_id;
      var impact_id = line.critical_impact_id;
      if (probability_id == null && impact_id == null) {
        return '';
      }
      var value = (probability_id ?? 0) * (impact_id ?? 0);
      if (probability_id == 10) {
          return 4;
      } else if (value < 9) {
          return 1;
      } else if (value <= 35) {                
          return 2;
      } else if (value <= 81) {
          return 3;
      } else {
          return 4;
      }
    }
    
}
